
import GalleryExport from "../../../assets/outline/GalleryExport.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function GalleryExportIcon({ className, dataTestid = "GalleryExportIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <GalleryExport data-testid={dataTestid} className={classes} {...rest} />
  );
}
